import fuego from 'utils/swrFirestore/fuego'

export const getBearerToken = async () => {
  return await fuego.auth().currentUser?.getIdToken()
}
